import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 상품글_미리보기_라우터 = {
  index: {
    path: '/upload/preview',
    async lazy() {
      const { default: Page } = await import('@/router/task/상품글_미리보기/index');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품글 미리보기 (세컨솔드)',
    },
  } satisfies LookoRouteObject,
  모바일: {
    path: '/upload/preview/mobile',
    async lazy() {
      const { default: Page } = await import('@/router/task/상품글_미리보기/모바일');
      return {
        Component: Page,
      };
    },
  } satisfies LookoRouteObject,
};

export const 상품글_미리보기_루트: LookoRouteObject = {
  path: '/',
  element: <Outlet />,
  children: values(상품글_미리보기_라우터),
};
